import React, { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { BuildPriceEntities } from 'client/data/models/build-price';
import { getAdsCustomTargeting, getModelYearById } from 'site-modules/shared/utils/build-price/build-price';
import { STEP_NUMBER } from 'site-modules/shared/constants/build-price';
import { BUILD_PRICE_SMILEY_SURVEY_CONFIG } from 'site-modules/build-price/constants/build-price';
import { IncentivesAd } from 'site-modules/shared/components/native-ad/incentives-ad/incentives-ad';
import { MrectNative } from 'site-modules/shared/components/native-ad/mrect/mrect-native';
import { BuildPriceVehicleSummary } from 'site-modules/build-price/components/build-price-vehicle-summary/build-price-vehicle-summary';
import { YearSubmodelSelect } from 'site-modules/build-price/components/steps/year-submodel-select/year-submodel-select';
import { Customize } from 'site-modules/build-price/components/steps/customize/customize';
import { StyleSelect } from 'site-modules/build-price/components/steps/style-select/style-select';
import { BuildSummary } from 'site-modules/build-price/components/steps/build-summary/build-summary';
import { SmileySurvey } from 'site-modules/shared/components/smiley-survey/smiley-survey';

export function BuildPriceStepsWrapper({
  buildPriceFilter,
  modelYears,
  pathname,
  isSummaryLeadFormSubmitted = false,
  isMobile = false,
}) {
  const [modelYear, setModelYear] = useState(getModelYearById(modelYears, buildPriceFilter.styleFilter.modelyearId));
  const { step } = buildPriceFilter;

  const setCurrentModelYear = useCallback(
    modelyearId => {
      setModelYear(getModelYearById(modelYears, modelyearId));
    },
    [modelYears]
  );

  if (step === STEP_NUMBER.STEP_5) {
    return null;
  }

  const commonStepProps = {
    buildPriceFilter,
    pathname,
    isMobile,
  };

  const ads10734WiredWrapperStyles = {
    boxShadow: '0px 4px 4px 0px #00000026',
    borderRadius: '8px',
  };

  return (
    <Row className="build-price-steps-wrapper mt-2 mt-md-1_5">
      <Col xs={12} lg={8}>
        {step === STEP_NUMBER.STEP_1 && (
          <YearSubmodelSelect {...commonStepProps} setCurrentModelYear={setCurrentModelYear} modelYear={modelYear} />
        )}
        {step === STEP_NUMBER.STEP_2_5 && <StyleSelect {...commonStepProps} modelYear={modelYear} />}
        {step === STEP_NUMBER.STEP_3 && <Customize {...commonStepProps} modelYear={modelYear} />}
        {step === STEP_NUMBER.STEP_4 && (
          <BuildSummary
            {...commonStepProps}
            modelYear={modelYear}
            isSummaryLeadFormSubmitted={isSummaryLeadFormSubmitted}
          />
        )}
      </Col>
      <Col xs={12} lg={4}>
        {!isMobile && (
          <div className="hidden-lg-down">
            {step <= STEP_NUMBER.STEP_2_5 && (
              <div style={ads10734WiredWrapperStyles}>
                <BuildPriceVehicleSummary buildPriceFilter={buildPriceFilter} modelYear={modelYear} />
                <IncentivesAd
                  wrapperClass="px-0"
                  mobile={isMobile}
                  customTargeting={getAdsCustomTargeting(buildPriceFilter.step)}
                  dropShadowLayout
                />
              </div>
            )}
            {step >= STEP_NUMBER.STEP_3 && (
              <BuildPriceVehicleSummary buildPriceFilter={buildPriceFilter} modelYear={modelYear} />
            )}
          </div>
        )}
        <Fragment>
          {step <= STEP_NUMBER.STEP_2_5 && isMobile && (
            <IncentivesAd
              wrapperClass="px-0 mt-1_5"
              mobile={isMobile}
              customTargeting={getAdsCustomTargeting(buildPriceFilter.step)}
              dropShadowLayout
            />
          )}
          {step >= STEP_NUMBER.STEP_3 && (
            <IncentivesAd
              wrapperClass="px-0 mt-1_5"
              mobile={isMobile}
              customTargeting={getAdsCustomTargeting(buildPriceFilter.step)}
              dropShadowLayout
              showDropShadow
            />
          )}
        </Fragment>
        {isMobile && step === STEP_NUMBER.STEP_3 && (
          <div className="mt-3">
            <MrectNative
              position={'1'}
              refreshable={false}
              mobileOnly
              customTargeting={getAdsCustomTargeting(buildPriceFilter.step)}
            />
          </div>
        )}
        {!isMobile && <SmileySurvey className="mt-2" {...BUILD_PRICE_SMILEY_SURVEY_CONFIG} />}
      </Col>
    </Row>
  );
}

BuildPriceStepsWrapper.propTypes = {
  modelYears: PropTypes.arrayOf(BuildPriceEntities.ModelYear).isRequired,
  buildPriceFilter: BuildPriceEntities.BuildPriceFilter.isRequired,
  pathname: PropTypes.string.isRequired,
  isSummaryLeadFormSubmitted: PropTypes.bool,
  isMobile: PropTypes.bool,
};
